// ============================================================================
// FAQ CONTENT — shared across Home preview, Plans and How It Works
// ============================================================================

export const faqs = [
  {
    q: "What does Green Circle Group actually do?",
    a: "Green Circle Group manages connected digital growth activities for Australian trade and home-service businesses. Depending on the plan, this can include local visibility, reviews, content, advertising, landing pages, lead capture, follow-up workflows, CRM support and appointment-booking assistance.",
  },
  {
    q: "Is Green Circle Group a digital marketing agency?",
    a: "Digital marketing is part of what we do, but the service extends beyond campaigns. Green Circle Group connects visibility, lead generation, customer response and business systems so growth activity works as one managed process.",
  },
  {
    q: "Who is Green Circle Group designed for?",
    a: "Green Circle Group is designed primarily for small and growing Australian trade and home-service businesses whose owners are busy running jobs, teams and customers and do not have enough time to manage business development consistently.",
  },
  {
    q: "Which plan should I choose?",
    a: "Get Found is for businesses that need a stronger local presence. Get Leads adds a managed lead-generation system. Cruise Control adds active lead response, follow-up and booking support. The initial Growth Assessment helps determine the most suitable starting point.",
  },
  {
    q: "Is advertising spend included?",
    a: "Advertising media spend is separate unless expressly included in a written proposal. This keeps the amount invested in advertising visible and allows it to be adjusted according to the market and objectives.",
  },
  {
    q: "Do you only use Meta advertising?",
    a: "No. The appropriate channel depends on the trade, service, location and customer intent. A strategy may use Google, Meta, retargeting, organic local visibility or a combination.",
  },
  {
    q: "Do you guarantee a certain number of leads or jobs?",
    a: "No responsible provider can guarantee a specific commercial result without considering the market, offer, competition, budget, capacity and sales process. Green Circle Group establishes clear measures, manages the agreed work and focuses on continual improvement.",
  },
  {
    q: "Will I lose control of my marketing or customer relationships?",
    a: "No. Cruise control means the agreed activity is managed consistently while you remain in control of the business, brand and major commercial decisions.",
  },
  {
    q: "Can you work with our existing website and systems?",
    a: "Often, yes. The Growth Assessment identifies what can be improved, connected or retained before recommending unnecessary replacement.",
  },
  {
    q: "Can you contact our old customers and previous enquiries?",
    a: "Potentially, where the contact data and proposed communication can be used appropriately. Any reactivation activity must follow applicable consent, privacy, identification and unsubscribe requirements.",
  },
  {
    q: "Do you work with competing businesses in the same area?",
    a: "Trade-category exclusivity may be available with the Cruise Control plan within an agreed service territory. Availability and boundaries must be confirmed in writing.",
  },
  {
    q: "How quickly will we see results?",
    a: "Timing varies by the starting position, trade, location, competition, offer, budget and selected services. The Growth Assessment and onboarding process establish realistic priorities and measures rather than making a generic promise.",
  },
];
